import React from 'react';
import { Box, Card, Avatar, CardContent, Typography } from '@mui/material';
import { useRef } from 'react';
import { useHistory } from 'react-router-dom';

export default function ProfileCard({ userInfo }) {
    const bannerInputRef = useRef(null);
    const profileInputRef = useRef(null);
    const history = useHistory();

    const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };
    return (
        <>
        {/* Profile Card */}
            <Card sx={{ width: '100%', maxWidth: 800, boxShadow: 3 }}>
                <Box sx={{ position: 'relative', height: 200 }}>
                {/* Banner image */}
                <Box
                    component="img"
                    src={userInfo?.bannerUrl || '/default-banner.jpg'}
                    alt="Banner"
                    sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderTopLeftRadius: 4,
                        borderTopRightRadius: 4,
                    }}
                />

                {/* Profile picture */}
                <Avatar
                    src={userInfo?.profileImageUrl || '/default-avatar.jpg'}
                    alt="Profile"
                    onClick={(e) => visitProfile(e, userInfo?._id)}
                    sx={{
                    width: 100,
                    height: 100,
                    position: 'absolute',
                    bottom: -50,
                    left: 24,
                    border: '3px solid white',

                    cursor: "pointer",
                    zIndex: 10, 
                    "&:hover": {
                    opacity: 0.9,
                    },
                    }}
                />

                </Box>
                <CardContent sx={{ pt: 6, position: 'relative' }}>
                    {/* Bottom row: name/occupation on left, company/university on right */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-end',
                        }}
                    >
                        {/* Left side */}
                        <Box>
                        <Typography variant="h6"
                        onClick={(e) => visitProfile(e, userInfo?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                        >
                            {userInfo?.first_name} {userInfo?.last_name}
                        </Typography>
                        <Typography 
                                variant="body2" 
                                color="text.secondary"
                                onClick={(e) => visitProfile(e, userInfo?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
                            >
                                @{userInfo?.username || 'unknown'}
                           </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {userInfo?.occupation || 'Your occupation'}
                        </Typography>
                        </Box>

                        {/* Right side */}
                        <Box textAlign="right">
                            <Typography variant="body2" color="text.primary">
                                {userInfo?.university || 'Your university'}
                            </Typography>
                            {/*<Typography variant="body2" color="text.secondary">
                                {userInfo?.company || 'Your company'}
                            </Typography>*/}
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </>
    );
}